import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51d286d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  class: "modal-card",
  tabindex: "0"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_6 = { class: "icon has-text-white" }
const _hoisted_7 = { class: "modal-card-title is-title-shrink" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("a", {
            class: "mr-3 is-flex",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.back()))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_fa_icon, {
                icon: "arrow-left",
                class: "fa-lg"
              })
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$gettext("Technical infos")), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
        })
      ]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.current.componentName), _normalizeProps(_guardReactiveProps(_ctx.current.params)), null, 16)),
      _hoisted_8
    ])
  ]))
}